import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppVideoDetailsPage } from './app-video-details';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    AppVideoDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppVideoDetailsPage),
    PipesModule,
    DirectivesModule,

    ComponentsModule,
  ],
})
export class AppVideoDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-video-details/app-video-details.module.ts